import { useEffect, useState } from "react";
import styles from "./feed.module.scss";

import * as api from "app/api/profile.api";
import { FeedObject } from "app/core/common";
import Feed from "app/components/feed/feed";
import { useHook } from "app/hooks/common";
import { CreateContent } from "app/components/createContent/createContent";

interface FeedItem {
  id: string;
  type: "video" | "image";
  image: {
    id: string;
  };
}

interface FeedData {
  feed: FeedItem[];
  meta: any;
}

interface Props {
  username: string;
  containerRef: any;
}

export default function ProfileFeed({ username, containerRef }: Props) {
  const { userInfo, checkingUserInfo } = useHook();

  const [profileFeed, setProfileFeed] = useState<FeedObject[]>([]);
  const [feedMeta, setFeedMeta] = useState<any>();
  const [page, setPage] = useState<number>(1);
  const [lastUpdated, setLastUpdated] = useState(new Date());
  const [moreExists, setMoreExists] = useState(true);
  const [loading, setLoading] = useState(true);

  // Check if user is on their own profile
  const isUserProfile = userInfo?.id === username;

  /* ===================== */
  /*  Fetch Feed */
  /* ===================== */
  useEffect(() => {
    const fetchProfileFeed = async () => {
      try {
        await api
          .GetProfileFeed({ id: username, page: page, userInfo: userInfo })
          .then((data) => {
            setProfileFeed((prevFeed) => [...prevFeed, ...data.feed]); //
            setFeedMeta(data.meta);
          });
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };

    if (username && page && loading && !checkingUserInfo) {
      fetchProfileFeed();
    }
  }, [username, userInfo, checkingUserInfo, page]);

  /* ===================== */
  /*  Fetch More Feed */
  /* ===================== */
  const fetchMoreFeed = () => {
    const totalPages =
      profileFeed.length > 0
        ? Math.ceil(feedMeta.filter_count / feedMeta.limit)
        : undefined;
    if (totalPages != undefined && page !== totalPages && moreExists) {
      setLoading(true);
      setPage(page + 1); // Increment page number
      setMoreExists(page + 1 <= totalPages); // Check if more pages exist
    }
  };

  return (
    <div className={styles.mainFeed}>
      {isUserProfile && (
        <CreateContent feedRef={profileFeed} updateFeedRef={setProfileFeed} />
      )}
      <Feed
        feed={profileFeed}
        feedLoading={loading}
        lastUpdated={lastUpdated}
        moreExists={moreExists}
        fetchMoreFeed={fetchMoreFeed}
        setFeed={setProfileFeed}
        containerRef={containerRef}
        isProfile={true}
        isUserProfile={isUserProfile}
      />
    </div>
  );
}
